import {Component, OnInit} from '@angular/core';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs/Observable';
import {Api} from '../../providers/api';
import {Auth} from '../../providers/auth';
import {EntitlementService} from '../../providers/entitlement.service';
import {Grupo} from '../../providers/models';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  name: string;
  grupos: Grupo[] = null;
  equipos = [];
  usuarios = [];

  cambios = false;

  isAdmin = false;

  circuito = {
    id: 0, guid: '', nombre: ''
  };


  showmodalEditar = false;

  showcreargrupo = false;

  showcrearequipo = false;
  showeditarequipo = false;
  item = {};

  // Invite modal
  showInviteModal = false;

  // Recovery link modal
  showRecoveryModal = false;
  recoveryTarget = null;

  // Edit user modal
  showEditUserModal = false;
  editUserTarget = null;

  // Admin static code
  adminStaticCode: string = null;
  adminCodeLoading = false;
  adminCodeCopied = false;
  adminCodeVisible = false;

  // Billing / Facturacion
  billingStatus: string = null;
  trialDaysRemaining: number = null;
  trialEndsAt: string = null;
  subscriptionExpiresAt: string | null = null;
  billingCycle: string | null = null;
  paymentProvider: string | null = null;
  daysUntilExpiry: number | null = null;
  billingLoading = false;
  billingError: string = null;

  // Link status (front-only, no new contract): equipos come from
  // GET /api/admin/getSettings (all Pos), while GET /api/admin/state
  // returns only Pos rows with TrackerEvent activity. An id present in
  // state counts as linked/reported; absent means created but never
  // reported (pending Vincular TV). Null = unknown = fail-open.
  linkedIds: {[id: number]: boolean} = null;

  // Entitlement gate (contratos-congelados Slice D1): selectors only, never raw status.
  screensInUse$: Observable<number | null>;
  maxScreens$: Observable<number | null>;
  isAtCap$: Observable<boolean>;
  planName$: Observable<string | null>;

  constructor(config: NgbDropdownConfig, private spinner: NgxSpinnerService,
              private api: Api, private auth: Auth, private entitlement: EntitlementService) {
    this.name = '';
    this.screensInUse$ = this.entitlement.screensInUse$;
    this.maxScreens$ = this.entitlement.maxScreens$;
    this.isAtCap$ = this.entitlement.isAtCap$;
    this.planName$ = this.entitlement.planName$;
    // customize default values of dropdowns used by this component tree
    config.placement = 'left-top';
    config.autoClose = true;
    this.spinner.hide();
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
      this.isAdmin = this.auth.user && this.auth.user.roleId === 1;
      console.log(this.circuito);
      this.getSettings();
      this.loadBillingStatus();
      this.loadVinculacion();
    }, (err) => {
      this.spinner.hide();
      this.auth.logout();
    });
  }

  showOptionesRow(screen) {
    console.log(screen);
  }

  ngOnInit() {

  }

  getSettings() {
    this.spinner.show();
    this.api.getSettings().subscribe((res: any) => {
      console.log(res);
      this.grupos = res.data.grupos;
      this.equipos = res.data.pos;
      this.usuarios = res.data.users;
      this.spinner.hide();
      if (this.isAdmin) {
        this.loadAdminCode();
      }
    }, err => {
      console.log(err);
      this.spinner.hide();
    });
  }

  loadVinculacion(): void {
    if (!this.api || typeof (this.api as any).getEstado !== 'function') {
      return;
    }
    this.api.getEstado().subscribe((res: any) => {
      const rows = (res && res.data && Array.isArray(res.data)) ? res.data
        : (Array.isArray(res) ? res : []);
      const map: {[id: number]: boolean} = {};
      rows.forEach((s: any) => {
        const id = Number(s && (s.idPos != null ? s.idPos : s.id));
        if (!isNaN(id)) {
          map[id] = true;
        }
      });
      this.linkedIds = map;
    }, err => {
      console.log(err);
      this.linkedIds = null;
    });
  }

  isVinculada(equipo: any): boolean | null {
    if (!this.linkedIds || !equipo || equipo.id == null) {
      return null;
    }
    return this.linkedIds[Number(equipo.id)] === true;
  }

  loadAdminCode(): void {
    this.adminCodeLoading = true;
    this.api.getMyStaticCode().subscribe((res: any) => {
      this.adminCodeLoading = false;
      if (res && res.data && res.data.code) {
        this.adminStaticCode = res.data.code;
      }
    }, err => {
      this.adminCodeLoading = false;
      console.log(err);
    });
  }

  copiarAdminCode(input: HTMLInputElement): void {
    if (!input) return;
    input.select();
    document.execCommand('copy');
    this.adminCodeCopied = true;
    setTimeout(() => this.adminCodeCopied = false, 2000);
  }

  toggleAdminCodeVisibility(): void {
    this.adminCodeVisible = !this.adminCodeVisible;
  }

  getMaskedAdminCode(): string {
    if (!this.adminStaticCode) return '';
    return this.adminStaticCode.replace(/./g, '•');
  }

  loadBillingStatus(): void {
    if (!this.circuito || !this.circuito.guid) return;
    this.billingLoading = true;
    this.billingError = null;
    this.api.getTrialStatus(this.circuito.guid).subscribe((res: any) => {
      const data = res && res.data ? res.data : res;
      // Reuse the already-fetched payload to feed the shared store (no new
      // endpoint call). Legacy payloads map to null-filled fail-open state.
      this.entitlement.setFromStatus(data);
      this.billingStatus = (data && (data.accountStatus || data.subscriptionStatus)) ? String(data.accountStatus || data.subscriptionStatus).toUpperCase() : null;
      this.subscriptionExpiresAt = data.subscriptionExpiresAt || data.subscription_expires_at || null;
      this.billingCycle = data.billingCycle || data.billing_cycle || null;
      this.paymentProvider = data.paymentProvider || data.payment_provider || null;
      if (data.daysUntilExpiry !== undefined && data.daysUntilExpiry !== null) {
        this.daysUntilExpiry = Number(data.daysUntilExpiry);
      } else if (this.subscriptionExpiresAt) {
        var diff2 = new Date(this.subscriptionExpiresAt).getTime() - Date.now();
        this.daysUntilExpiry = Math.max(0, Math.ceil(diff2 / (1000 * 60 * 60 * 24)));
      } else {
        this.daysUntilExpiry = null;
      }
      if (data && data.trialEndsAt) {
        this.trialEndsAt = data.trialEndsAt;
        const diff = new Date(data.trialEndsAt).getTime() - Date.now();
        this.trialDaysRemaining = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
      } else if (this.billingStatus === 'TRIAL' && this.subscriptionExpiresAt) {
        this.trialEndsAt = this.subscriptionExpiresAt;
        this.trialDaysRemaining = this.daysUntilExpiry;
      } else {
        this.trialEndsAt = this.trialEndsAt || null;
        if (this.billingStatus !== 'TRIAL') {
          this.trialDaysRemaining = this.daysUntilExpiry;
        }
      }
      this.billingLoading = false;
    }, (err) => {
      this.billingLoading = false;
      this.billingError = 'No se pudo cargar la facturación';
    });
  }

  get billingLabel(): string {
    switch (this.billingStatus) {
      case 'TRIAL': return 'Prueba';
      case 'ACTIVE': return 'Activa';
      case 'EXPIRED': return 'Vencida';
      case 'LIFETIME': return 'Vitalicia';
      default: return '—';
    }
  }

  get billingBadgeClass(): string {
    switch (this.billingStatus) {
      case 'TRIAL': return 'badge-warning';
      case 'ACTIVE': return 'badge-success';
      case 'EXPIRED': return 'badge-danger';
      case 'LIFETIME': return 'badge-info';
      default: return 'badge-secondary';
    }
  }

  get formattedExpiresAt(): string {
    if (!this.subscriptionExpiresAt) return '-';
    var d = new Date(this.subscriptionExpiresAt);
    if (isNaN(d.getTime())) return this.subscriptionExpiresAt;
    var dd = ('0' + d.getDate()).slice(-2);
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var yyyy = d.getFullYear();
    return dd + '/' + mm + '/' + yyyy;
  }

  get showRenewCTA(): boolean {
    if (this.billingStatus === 'EXPIRED') return true;
    if (this.billingStatus === 'ACTIVE' && this.daysUntilExpiry !== null && this.daysUntilExpiry <= 7) return true;
    if (this.billingStatus === 'TRIAL') return true;
    return false;
  }

  get isLifetime(): boolean { return this.billingStatus === 'LIFETIME'; }

  getgrupo(grupos, equipo) {
    let grupo;
    grupos.forEach((_grupo) => {
      if (_grupo.id === equipo.idGrupo) {
        grupo = _grupo;
      }
    });
    return grupo;
  }


  crearGrupo() {
    this.item = {
      titulo: 'Crear Grupo',
      placeholder: 'Agrege el nombre del grupo',
      value: {nombre: ''}
    };
    this.showcreargrupo = true;
  }

  successcrearGrupo(value) {
    console.log(value);
    this.showcreargrupo = false;
    this.spinner.show();
    this.api.crearGrupo({idCircuito: this.circuito.id, nombre: value.nombre})
      .subscribe((res) => {
        console.log(res);
        this.getSettings();
      }, err => {
        this.spinner.hide();
      });
  }

  eliminarGrupo(grupo) {
    this.spinner.show();
    this.api.eliminarGrupo(grupo).subscribe((res) => {
      console.log(res);
      this.getSettings();
    }, err => {
      this.spinner.hide();
    });
  }

  editarGrupo(grupo) {
    this.item = {
      titulo: 'Editar Grupo',
      placeholder: '',
      value: grupo
    };
    this.showmodalEditar = true;
  }

  successEditar(grupo) {
    this.showmodalEditar = false;
    this.spinner.show();
    this.api.editarGrupo(grupo).subscribe((res) => {
      console.log(res);
      this.getSettings();
    }, err => {
      this.spinner.hide();
    });
  }

  /**Equipos*/

  crearEquipo() {
    this.item = {
      titulo: 'Crear Equipo',
      placeholder: '',
      value: {
        nombre: '',
        modelo: '',
        sdFecha: Date.now(),
        idGrupo: 0,
        ubicacion: ''
      }
    };
    console.log(this.item);
    this.showcrearequipo = true;
  }

  successCrearEquipo(equipo) {
    console.log(equipo);
    this.showcrearequipo = false;
    this.spinner.show();
    this.api.crearEquipo(equipo).subscribe((res) => {
      console.log(res);
      this.getSettings();
    }, err => {
      console.log(err);
      this.spinner.hide();
    });
  }

  editarEquipo(index, equipo) {
    console.log(equipo);
    console.log(this.equipos[index]);
    this.item = {
      titulo: 'Editar Equipo',
      placeholder: '',
      value: equipo
    };
    console.log(this.item);
    this.showeditarequipo = true;
  }

  successEditarEquipo(equipo) {
    console.log(equipo);
    this.showeditarequipo = false;
    this.spinner.show();
    this.api.editarEquipo(equipo).subscribe((res) => {
      console.log(res);
      this.getSettings();
    }, err => {
      console.log(err);
      this.spinner.hide();
    });
  }

  eliminarEquipo(index, equipo) {
    this.spinner.show();
    this.api.eliminarEquipo(equipo).subscribe((res) => {
      console.log(res);
      this.getSettings();
    }, err => {
      this.spinner.hide();
    });
  }

  // Invite modal
  abrirInviteModal(): void {
    this.showInviteModal = true
  }

  cerrarInviteModal(): void {
    this.showInviteModal = false
  }

  // Recovery link modal
  abrirRecoveryModal(user): void {
    this.recoveryTarget = user
    this.showRecoveryModal = true
  }

  cerrarRecoveryModal(): void {
    this.showRecoveryModal = false
  }

  // Edit user modal
  abrirEditarUsuario(user): void {
    this.editUserTarget = user
    this.showEditUserModal = true
  }

  cerrarEditarUsuario(): void {
    this.showEditUserModal = false
  }

  guardarEditarUsuario(data): void {
    this.spinner.show();
    const payload: any = {
      id: this.editUserTarget.id,
      name: data.name
    };
    // Solo se envía roleId para filas de otros usuarios: el admin no puede
    // cambiar su propio rol, y si lo mandamos el backend lo rechaza con 400.
    if (this.puedeEditarRol(this.editUserTarget)) {
      payload.roleId = data.roleId;
    }
    this.api.updateUser(payload).subscribe((res: any) => {
      console.log(res);
      this.cerrarEditarUsuario();
      this.getSettings();
    }, err => {
      console.log(err);
      this.spinner.hide();
    });
  }

  puedeEditarRol(user): boolean {
    return !this.esUsuarioActual(user)
  }

  activarUsuario(user): void {
    this.spinner.show();
    this.api.setUserActivated(user.id, 1).subscribe((res: any) => {
      user.emailConfirmed = 1;
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  estaActivo(user): boolean {
    return Number(user && user.emailConfirmed) === 1
  }

  showActivateModal = false;
  activateTarget: any = null;
  activateMensaje = '';

  abrirActivarModal(user): void {
    this.activateTarget = user;
    this.activateMensaje = '¿Seguro que desea activar la cuenta de ' + (user.name || user.email) + '?';
    this.showActivateModal = true;
  }

  cerrarActivarModal(): void {
    this.showActivateModal = false;
  }

  confirmarActivacion(): void {
    this.cerrarActivarModal();
    this.activarUsuario(this.activateTarget);
  }

  toggleUserLockout(user): void {
    const targetLockout = user.lockout ? 0 : 1;
    this.spinner.show();
    this.api.setUserLockout(user.id, targetLockout).subscribe((res: any) => {
      user.lockout = targetLockout;
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  esUsuarioActual(user): boolean {
    return user && this.auth.user && user.email === this.auth.user.email
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/setting/setting.component.ts